import React from 'react';
import { Col } from 'virtues-bootstrap';
import TopMenu from 'components/ui/TopMenu';
import UserInfo from 'containers/Header/UserInfo';
import CommonHeader from './CommonHeader';

function TechnicianHeader() {
  const topMenuItems = [
    {
      to: '/patient-list',
      text: 'header.patientList',
    },
    {
      to: '/reports',
      text: 'header.virtuesReports',
    },
  ];

  return (
    <CommonHeader>
      <Col xs={6}>
        <TopMenu items={topMenuItems} />
      </Col>
      <Col xs={3}>
        <UserInfo />
      </Col>
    </CommonHeader>
  );
}

export default TechnicianHeader;
